import partner from './partner.schema';

export default {
  title: 'partner registration',
  type: 'object',
  properties: {
    login: {
      type: 'string',
      title: 'Nazwa użytkownika',
      format: 'email',
      fieldRequired: false,
      calc: '$root.profile.email',
      validationMessages: {
        format: 'Login użytkownika musi być adresem e-mail'
      }
    },
    profile: {
      title: 'profile',
      type: 'object',
      properties: {
        type: {
          title: 'Typ konta',
          type: 'number',
          fieldRequired: false
        },
        firstName: {
          title: 'Imię użytkownika',
          type: 'string',
          fieldRequired: true,
          maxLength: 500
        },
        lastName: {
          title: 'Nazwisko użytkownika',
          type: 'string',
          fieldRequired: true,
          maxLength: 500
        },
        email: {
          title: 'Adres e-mail',
          type: 'string',
          format: 'email',
          fieldRequired: true,
          validationMessages: {
            format: 'Niepoprawny adres e-mail'
          }
        }
      }
    },
    partner
  }
};
